import { Card, Page, Layout, Text, Badge, Button, TextContainer, Divider } from '@shopify/polaris';
import React, { Component } from 'react';
import { SkeletonPageCustom } from './SkeletonPageCustom';
import '../modern.css';

export class Plans extends Component {
    constructor(props) {
        super(props);
        this.state = { isLoading: true, errorMessage: '', code: '', shopNameError: '', url: window.location.search };
    }

    componentDidMount() {
        this.populateData();
    }

    async populateData() {
        const response = await fetch('api/home/SubscriptionPlans');
        const data = await response.json();
        this.setState({ data: data, isLoading: false });
    }

    render() {

        let isFreePlanActivated = false;
        let isMonthlyPlanActivated = false;
        let isAnnualPlanActivated = false;
        let freeTitle = "";
        let monthlyTitle = "";
        let annualTitle = "";

        if (!this.state.isLoading) {
            isFreePlanActivated = this.props.common.hasFreePlanActivated;
            isMonthlyPlanActivated = this.props.common.hasTrialPlan == false && this.props.common.hasAnnualPlanActivated == false && this.props.common.hasMonthlyPlanActivated;
            isAnnualPlanActivated = this.props.common.hasTrialPlan == false && this.props.common.hasAnnualPlanActivated;
            freeTitle = `Free plan`;
            monthlyTitle = `Shopify ${this.props.common.planDisplayName} : monthly`;
            annualTitle = `Shopify ${this.props.common.planDisplayName} : annually`;
        }
        const freeFeatureList = [
            "UP TO 25 ADD TO CARTS ONLY per month",
            "Sticky add to cart bar",
            "Countdown timer urgency bar",
            "Floating sticky cart icons",
            "Sticky cart & Sticky checkout bars",
            "Quick view, quick buy, & Buy now buttons",
            "Slider cart drawer w / in cart upsell",
        ];
        const featureList = [
            'Sticky add to cart bar',
            'NEW: Countdown timer urgency bar',
            'Floating sticky cart icons',
            'Sticky cart & Sticky checkout bars',
            'Quick view, quick buy, & Buy now buttons',
            'Slider cart drawer w/ in cart upsell',
        ];

        const freeSupportText = 'BASIC onboarding & support';
        const monthlySupportText = 'PRIORITY  onboarding & support';
        const annualSupportText = 'PRIORITY onboarding & support';
        
        return (
            this.state.isLoading ?
                <SkeletonPageCustom />
                :
                <Page title="Subscription options" className="x">
                <div className="modern-onboarding">

                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', justifyContent: 'center' }}>
                        <div style={{ flex: '1 1 30%', minWidth: '300px' }}>
                            <div style={{ borderRadius: '8px', overflow: 'hidden', border: '1px solid #DFE3E8' }}>
                                <Card
                                    title={freeTitle}
                                    sectioned
                                    primaryFooterAction={{
                                        content: isFreePlanActivated ? 'Currently subscribed' : 'Select plan',
                                        disabled: isFreePlanActivated,
                                        onAction: () => {
                                            const navUrl = 'https://stickyaddtocartbar.azurewebsites.net/Account/ActivatePlan?shop=' + this.props.common.shopName + "&isFreePlan=true";
                                            window.open(navUrl, '_top');
                                        }
                                    }}
                                >
                                    <TextContainer spacing="tight">
                                        <Divider />
                                        <Text variant="headingSm">Features</Text>
                                        <div style={{ lineHeight: '1.6' }}>
                                            {freeFeatureList.map((feature, index) => (
                                                <div key={index}>✓  {feature}</div>
                                            ))}
                                            <div key={freeFeatureList.length}>✓ {freeSupportText} </div>
                                        </div>
                                    </TextContainer>
                                    <br/>
                                    <Text variant="bodyMd" color="critical" as="p" style={{ fontWeight: 600 }}>
                                        STKY features will pause automatically after 25 clicks are reached. Count will reset and unpause every 30 days.
                                    </Text>
                                </Card>
                            </div>
                        </div>

                        <div style={{ flex: '1 1 30%', minWidth: '300px' }}>
                            <div style={{ borderRadius: '8px', overflow: 'hidden', border: '1px solid #DFE3E8' }}>

                                <div style={{ backgroundColor: '#108043', color: 'white', textAlign: 'center', padding: '6px 0', fontWeight: 500, fontSize: "18px" }}>
                                    Save 30% annually
                                </div>
                                <Card
                                    title={annualTitle}
                                    sectioned
                                    primaryFooterAction={{
                                        content: isAnnualPlanActivated ? 'Currently subscribed' : 'Select plan',
                                        disabled: isAnnualPlanActivated,
                                        onAction: () => {
                                            const navUrl = 'https://stickyaddtocartbar.azurewebsites.net/Account/ActivatePlan?shop=' + this.props.common.shopName + "&isAnnualPlan=true";
                                            window.open(navUrl, '_top');
                                        }
                                    }}
                                >
                                    <Text variant="bodyMd" color="success">
                                        Save 30% annually {isAnnualPlanActivated && <Badge status="success">Current Plan</Badge>}
                                    </Text>
                                    <TextContainer spacing="tight">
                                        <p style={{ marginTop: '8px' }}><strong style={{ fontSize: '20px', marginTop: '10px' }}>${(this.state.data.annualPlanPrice / 12).toFixed(2)}</strong>/month</p>
                                        <p>Total annual price ${this.state.data.annualPlanPrice}/year</p>
                                        <Divider />
                                        <Text variant="headingSm">Features</Text>
                                        <div style={{ lineHeight: '1.6' }}>
                                            {featureList.map((feature, index) => (
                                                <div key={index}>✓  {feature}</div>
                                            ))}
                                            <div key={featureList.length}>✓ {annualSupportText} </div>
                                        </div>
                                    </TextContainer>
                                </Card>
                            </div>
                        </div>

                        <div style={{ flex: '1 1 30%', minWidth: '300px' }}>
                            <Card
                                title={monthlyTitle}
                                sectioned
                                primaryFooterAction={{
                                    content: isMonthlyPlanActivated ? 'Currently subscribed' : 'Select plan',
                                    disabled: isMonthlyPlanActivated,
                                    onAction: () => {
                                        const navUrl = 'https://stickyaddtocartbar.azurewebsites.net/Account/ActivatePlan?shop=' + this.props.common.shopName + "&isAnnualPlan=false";
                                        window.open(navUrl, '_top');
                                    }
                                }}
                            >
                                <TextContainer spacing="tight">
                                    <p><strong style={{ fontSize: '20px', marginTop: '10px' }}>${this.state.data.monthlyPlanPrice}</strong>/month {isMonthlyPlanActivated && <Badge status="success">Current Plan</Badge>}</p>
                                    <Divider />

                                    <Text variant="headingSm">Features</Text>
                                    <div style={{ lineHeight: '1.6' }}>
                                        {featureList.map((feature, index) => (
                                            <div key={index}>✓  {feature}</div>
                                        ))}
                                        <div key={featureList.length}>✓ {monthlySupportText} </div>
                                    </div>
                                </TextContainer>
                            </Card>
                        </div>
                    </div>
                </div>
                </Page>
        );
    }
}
